import { render, staticRenderFns } from "./AccountAddress.vue?vue&type=template&id=34c1b139&scoped=true&lang=pug"
import script from "./AccountAddress.vue?vue&type=script&lang=js"
export * from "./AccountAddress.vue?vue&type=script&lang=js"
import style0 from "./AccountAddress.vue?vue&type=style&index=0&id=34c1b139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c1b139",
  null
  
)

export default component.exports